module.exports = __webpack_public_path__ + "img/Icon_Youtube.65ef47d8.svg";